import { isDefined } from '@sgme/fp';

export function optionalMap<T, U = T>(transformer: (val: T) => U): (val?: T) => U | undefined {
  return function optionalMapper(val?: T) {
    return isDefined(val) ? transformer(val) : val;
  };
}
